import { createUid } from '@Utils/miscUtils';
import type { ScrollViewManager } from '@Utils/scroll-view-manager/scroll-view-manager';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { View, Text } from 'react-native';

type Props = {
  id?: string;
  manager: ScrollViewManager;
  children?: ReactNode;
  autoFocus?: boolean;
  troubleshooting?: boolean;
};

// Serves as a scroll-target within a scroll-view
export const ScrollViewMarker = observer(function ScrollViewMarker({
  manager,
  id,
  children,
  autoFocus, // if true, will trigger scroll to this marker on mount
  troubleshooting,
}: Props) {
  // we need to provide external id only when we need to trigger the scroll, from outside the component
  const [effectiveId] = useState(id ?? createUid());

  const setRef = (ref: View) => {
    manager.updateMarker(effectiveId, ref);
  };

  useEffect(() => {
    if (autoFocus) {
      manager.scrollToId(effectiveId).then();
    }

    return () => {
      manager.deleteMarker(effectiveId);
    };
  }, []);

  const style = troubleshooting
    ? { width: 300, height: 25, backgroundColor: 'pink' }
    : {};

  return (
    <View ref={setRef} style={style}>
      {troubleshooting && <Text>{effectiveId}</Text>}
      {children}
    </View>
  );
});
